import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const SectionHeading = ({ eyebrow, title, copy, align = "left" }) => (
    <Reveal className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
        <p className="text-xs font-medium uppercase tracking-[0.28em] text-saffron" data-testid="section-eyebrow">{eyebrow}</p>
        <h2 className="mt-4 font-serif text-3xl font-semibold leading-[1.05] tracking-tight text-ink md:text-4xl" data-testid="section-title">
            {title}
        </h2>
        {copy && <p className="mt-5 text-base leading-relaxed text-muted-foreground md:text-lg">{copy}</p>}
    </Reveal>
);
